const AutomaticCreditCardDeclinesFilterStyle = ({
    firstLabel: { paddingBottom: '16px' },
    restLabels: { padding: '8px 0' },
    clearDate: { justifyContent: 'end' },
});

export default AutomaticCreditCardDeclinesFilterStyle;
